import type { SVGProps } from "react";
export interface SignatureDocumentIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SignatureDocumentIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SignatureDocumentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M16.875 9.441V5c0-1.035-.84-1.875-1.874-1.875H5c-1.036 0-1.875.84-1.875 1.875v14c0 1.035.84 1.875 1.875 1.875h5.322l.116.005a1.126 1.126 0 0 1 0 2.239l-.116.006H5A4.125 4.125 0 0 1 .875 19V5A4.125 4.125 0 0 1 5 .875h10A4.125 4.125 0 0 1 19.126 5v4.441a1.125 1.125 0 0 1-2.25 0Z"
      />
      <path
        fill={color}
        d="M16.375 14.75a.626.626 0 0 0-1.25 0v.75a1.125 1.125 0 0 1-2.25 0v-.75a2.876 2.876 0 0 1 5.75 0v.674c.4-.112.769-.217 1.07-.3.178-.05.41-.1.655-.093.243.007.66.075.987.434.326.358.357.78.341 1.02a2 2 0 0 1-.07.39H22l.115.006a1.126 1.126 0 0 1 0 2.239l-.114.005h-1.424c-.154 0-.36-.01-.573-.073a1.37 1.37 0 0 1-.755-.532 1.37 1.37 0 0 1-.234-.87l-.483.137c-.04.505-.095 1.015-.179 1.434-.087.437-.237 1.349-.593 2.124-.367.796-1.116 1.78-2.51 1.78-1.204 0-1.801-.94-2.046-1.55-.258-.645-.331-1.363-.33-1.83.004-.962.4-2.688 2.27-3.312.259-.086.705-.219 1.223-.369a26 26 0 0 0 .008-.564zm-.52 3.817a.93.93 0 0 0-.562.459 1.6 1.6 0 0 0-.168.728c-.002.282.05.691.168.984.02.05.043.09.06.12.095-.032.214-.132.362-.454.218-.474.32-1.062.432-1.624q.028-.145.051-.318zM10.7 10.876l.116.005a1.125 1.125 0 0 1 0 2.239l-.116.006H6a1.125 1.125 0 0 1 0-2.25zM14 6.875a1.125 1.125 0 0 1 0 2.25H6a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
